import React from 'react';
import { CheckIcon } from 'lucide-react';
import { systemIncludes } from '../data/breakFreeContent';
export function IncludesSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="includes-title" data-id="element-103" data-mp="2dr18pzqcw3lk">
      <div className="mx-auto max-w-3xl px-5" data-id="element-104" data-mp="28x6i0ccc2ocz">
        <div className="border border-champagne/25 bg-charcoal-900 px-6 py-8 sm:px-10" data-id="element-105" data-mp="23zesfoz5veby">
          <h2 id="includes-title" className="font-display text-xl font-semibold uppercase tracking-wide text-ivory-50 sm:text-2xl" data-id="element-106" data-mp="1z1lm8vxuykbo">
            The system gives you:
          </h2>
          <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-107" data-mp="1q1q94lkqsf90">
            {systemIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-108" data-mp="1l2vn7arhaako">
                <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-109" data-mp="3kf7wo8l5dc41" />
                <span className="text-[14px] leading-snug text-ivory-200" data-id="element-110" data-mp="3uh0c168vwuur">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}